
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2F875", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f05b44396477b87$export$2e2bcd8739ae039; });

var $l3ZFM = parcelRequire("l3ZFM");
class $1f05b44396477b87$export$2e2bcd8739ae039 {
    constructor({ canvas: canvas, width: width = 500, height: height = 500, padding: padding = 20, context: context = "2d", fps: fps = 60 }){
        this.canvas = canvas;
        this.ctx = this.canvas.getContext(context);
        this.canvas.setAttribute("width", width);
        this.canvas.setAttribute("height", height);
        this.width = width;
        this.height = height;
        this.centerX = width / 2;
        this.centerY = height / 2;
        this.padding = padding;
        this.innerWidth = this.width - 2 * this.padding;
        this.innerHeight = this.height - 2 * this.padding;
        this.drawId = null;
        this.fps = fps;
    }
    setup() {}
    update() {}
    draw() {}
    mouseClick(x, y) {}
    async start() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.addEventListener("click", this.eventClick.bind(this), false);
        await this.setup();
        this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    tick() {
        const startTime = Date.now();
        this.update();
        this.draw();
        const endTime = Date.now();
        const deltaTime = endTime - startTime;
        const waitTime = 1000 / this.fps - deltaTime;
        if (waitTime > 0) setTimeout(()=>{
            this.drawId = requestAnimationFrame(this.tick.bind(this));
        }, waitTime);
        else this.drawId = requestAnimationFrame(this.tick.bind(this));
    }
    eventClick(e) {
        // get position of cursor relative to top left of canvas
        let x;
        let y;
        if (e.pageX || e.pageY) {
            x = e.pageX;
            y = e.pageY;
        } else {
            x = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        x -= this.canvas.offsetLeft;
        y -= this.canvas.offsetTop;
        this.mouseClick(x, y);
    }
    clear() {
        this.ctx.clearRect(0, 0, this.width, this.height);
    }
    drawRectangle(x, y, w, h, color) {
        this.ctx.beginPath();
        this.ctx.rect(x, y, w, h);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCircle(x, y, r, color) {
        this.ctx.beginPath();
        this.ctx.arc(x, y, r, 0, Math.PI * 2, true);
        this.ctx.closePath();
        this.ctx.fillStyle = color;
        this.ctx.fill();
    }
    drawCoordinatePlan(xMin = -5, xMax = 5, yMin = -5, yMax = 5) {
        const padding = 20;
        const innerWidth = this.width - 2 * padding;
        const innerHeight = this.height - 2 * padding;
        const mapX = (x)=>padding + (x - xMin) / (xMax - xMin) * innerWidth;
        const mapY = (y)=>this.height - padding - (y - yMin) / (yMax - yMin) * innerHeight;
        this.ctx.lineWidth = 1;
        this.ctx.setLineDash([]);
        // Draw the x-axis
        this.ctx.beginPath();
        this.ctx.moveTo(padding, this.centerY);
        this.ctx.lineTo(this.width - padding, this.centerY);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw the y-axis
        this.ctx.beginPath();
        this.ctx.moveTo(this.centerX, padding);
        this.ctx.lineTo(this.centerX, this.height - padding);
        this.ctx.strokeStyle = "#100c09";
        this.ctx.stroke();
        // Draw ticks and labels on x-axis
        (0, $l3ZFM.default)(xMin, xMax + 1).forEach((x, i)=>{
            const xPos = mapX(x);
            this.ctx.beginPath();
            this.ctx.moveTo(xPos, this.centerY - 5);
            this.ctx.lineTo(xPos, this.centerY + 5);
            this.ctx.stroke();
            if (x !== 0 && !(i % 2)) this.ctx.fillText(x, xPos - 3, this.centerY + 15);
        });
        // Draw ticks and labels on y-axis
        (0, $l3ZFM.default)(yMin, yMax + 1).forEach((y, i)=>{
            const yPos = mapY(y);
            this.ctx.beginPath();
            this.ctx.moveTo(this.centerX - 5, yPos);
            this.ctx.lineTo(this.centerX + 5, yPos);
            this.ctx.stroke();
            if (y !== 0 && !(i % 2)) this.ctx.fillText(y, this.centerX + 10, yPos + 3);
        });
    }
}

});
parcelRegister("l3ZFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f559b7bb01552f0a$export$2e2bcd8739ae039; });
var $f559b7bb01552f0a$export$2e2bcd8739ae039 = (from, to, increment = 1)=>[
        ...Array(Math.ceil((to - from) / increment)).keys()
    ].map((i)=>from + i * increment);

});


parcelRegister("5yyu4", function(module, exports) {

$parcel$export(module.exports, "generateLinearData", function () { return $40bae082d3346e42$export$6c2fe876829088e1; });
$parcel$export(module.exports, "default", function () { return $40bae082d3346e42$export$2e2bcd8739ae039; });
const $40bae082d3346e42$var$getRandomBetween = (low, high)=>Math.random() * (high - low) + low;
const $40bae082d3346e42$export$5907fc7152c4333c = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $40bae082d3346e42$var$getRandomBetween(0.05, 0.2);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach(()=>{
        const r = $40bae082d3346e42$var$getRandomBetween(0.3, 0.45);
        const t = Math.random() * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $40bae082d3346e42$export$6f53b2aedd0eab0b = (nSamples)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(1);
    });
    Array.from({
        length: nSamples / 2
    }).forEach((_, i)=>{
        const r = i / (nSamples / 2) * 0.5;
        const t = 1.25 * i / (nSamples / 2) * 2 * Math.PI + Math.PI;
        data.push([
            0.5 + r * Math.sin(t),
            0.5 + r * Math.cos(t)
        ]);
        labels.push(-1);
    });
    return [
        data,
        labels
    ];
};
const $40bae082d3346e42$export$6c2fe876829088e1 = (nSamples, fn = (x, y)=>y > 0.4 * x + 0.2 && -1 || 1)=>{
    const data = [];
    const labels = [];
    Array.from({
        length: nSamples
    }).forEach(()=>{
        const x = $40bae082d3346e42$var$getRandomBetween(0, 0.99);
        const y = $40bae082d3346e42$var$getRandomBetween(0, 0.99);
        data.push([
            x,
            y
        ]);
        labels.push(fn(x, y));
    });
    return [
        data,
        labels
    ];
};
const $40bae082d3346e42$var$generatePatternData = (shape, nSamples)=>{
    switch(shape){
        case "circles":
            return $40bae082d3346e42$export$5907fc7152c4333c(nSamples);
        case "spirals":
            return $40bae082d3346e42$export$6f53b2aedd0eab0b(nSamples);
        case "linear":
            return $40bae082d3346e42$export$6c2fe876829088e1(nSamples);
        default:
            return [];
    }
};
var $40bae082d3346e42$export$2e2bcd8739ae039 = $40bae082d3346e42$var$generatePatternData;

});


var $9bnV0 = parcelRequire("9bnV0");

var $2F875 = parcelRequire("2F875");

var $5yyu4 = parcelRequire("5yyu4");

var $l3ZFM = parcelRequire("l3ZFM");

var $9bnV0 = parcelRequire("9bnV0");
const $bfcdf511b23dacc3$var$buildModel = ()=>{
    const numOfInputs = 2;
    const layer1 = new (0, $9bnV0.Layer)({
        numOfInputs: numOfInputs,
        numOfNeurons: 16
    });
    const layer2 = new (0, $9bnV0.Layer)({
        numOfInputs: 16,
        numOfNeurons: 16
    });
    const layer3 = new (0, $9bnV0.Layer)({
        numOfInputs: 16,
        numOfNeurons: 1,
        activation: "linear"
    });
    const model = new (0, $9bnV0.Sequential)({
        layers: [
            layer1,
            layer2,
            layer3
        ]
    });
    return model;
};
var $bfcdf511b23dacc3$export$2e2bcd8739ae039 = $bfcdf511b23dacc3$var$buildModel;



var $3P6oo = parcelRequire("3P6oo");
const $f54e63fc4e22fdb3$var$size = Math.min(+document.querySelector(".demo").offsetWidth, 600);
const $f54e63fc4e22fdb3$var$percent = (v)=>new Intl.NumberFormat("en-US", {
        style: "percent"
    }).format(v);
class $f54e63fc4e22fdb3$var$BinaryClassification extends (0, $2F875.default) {
    constructor({ canvas: canvas, lossCanvas: lossCanvas }){
        super({
            canvas: canvas
        });
        this.pattern = "circles";
        this.lossCanvas = lossCanvas;
        this.ctxLoss = this.lossCanvas.getContext("2d");
        this.lossCanvas.setAttribute("width", $f54e63fc4e22fdb3$var$size);
        this.lossCanvas.setAttribute("height", 200);
        this.model = (0, $bfcdf511b23dacc3$export$2e2bcd8739ae039)();
        this.training = false;
        this.trainId = null;
        this.drawId = null;
        this.maxEpochs = 500;
        this.trainingData = [];
        this.lossHistory = [];
    }
    getPattern() {
        return this.pattern;
    }
    setPattern(pattern) {
        this.pattern = pattern;
    }
    mapX(x) {
        return this.padding + x * this.innerWidth;
    }
    mapY(y) {
        return this.height - this.padding - y * this.innerHeight;
    }
    plotPattern() {
        const [data, labels] = this.trainingData;
        data.forEach((point, index)=>{
            const [x, y] = point;
            const label = labels[index];
            const color = label === 1 && "#3a7ca5" || label === -1 && "#f6511d" || "#006632";
            this.drawCircle(this.mapX(x), this.mapY(y), 5, color);
        });
    }
    plotBoundaries() {
        const step = 0.05;
        const xRange = (0, $l3ZFM.default)(0, 1, step);
        const yRange = (0, $l3ZFM.default)(0, 1, step);
        yRange.forEach((y)=>{
            xRange.forEach((x)=>{
                const prediction = this.model.forward([
                    x,
                    y
                ]);
                const label = prediction.data > 0 ? 1 : -1;
                const color = label === 1 && "rgb(58 124 165 / 20%)" || label === -1 && "rgb(246 81 29 / 20%)" || "rgb(0 102 50 / 20%)";
                this.drawRectangle(this.mapX(x), this.mapY(y), step * this.innerWidth, step * this.innerHeight, color);
            });
        });
    }
    plotLossCurve() {
        const { lossCanvas: lossCanvas, ctxLoss: ctxLoss, lossHistory: lossHistory } = this;
        if (lossHistory.length < 2) return;
        const { width: width } = lossCanvas;
        const { height: height } = lossCanvas;
        const padding = 25;
        const plotWidth = width - 2 * padding;
        const plotHeight = height - 2 * padding;
        // Clear the previous plot
        ctxLoss.clearRect(0, 0, width, height);
        // Set up the drawing area
        ctxLoss.strokeStyle = "#856a5d";
        ctxLoss.lineWidth = 2;
        ctxLoss.beginPath();
        // Find the maximum loss for scaling
        const maxLoss = Math.max(...lossHistory);
        lossHistory.forEach((loss, index)=>{
            const x = padding + index / (this.maxEpochs - 1) * plotWidth;
            const y = height - padding - loss / maxLoss * plotHeight;
            if (index === 0) ctxLoss.moveTo(x, y);
            else ctxLoss.lineTo(x, y);
        });
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw x-axis
        ctxLoss.strokeStyle = "#100c09";
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(width - padding, height - padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Draw y-axis
        ctxLoss.beginPath();
        ctxLoss.moveTo(padding, height - padding);
        ctxLoss.lineTo(padding, padding);
        ctxLoss.stroke();
        ctxLoss.closePath();
        // Add x-axis label
        ctxLoss.fillStyle = "#100c09";
        ctxLoss.font = "12px Arial";
        ctxLoss.fillText("Epochs", width / 2, height - padding / 4);
        // Add y-axis label
        ctxLoss.save();
        ctxLoss.translate(padding / 2, height / 2);
        ctxLoss.rotate(-Math.PI / 2);
        ctxLoss.textAlign = "center";
        ctxLoss.fillText("Loss", 0, 0);
        ctxLoss.restore();
    }
    train() {
        const [xs, ys] = this.trainingData;
        let epoch = 0;
        let learningRate = 0.8;
        const alpha = 1e-4;
        const batch = xs.length;
        const trainStep = ()=>{
            if (!this.training) return;
            // Shuffle and get batch indices
            let indices = (0, $l3ZFM.default)(0, xs.length).sort(()=>Math.random() - 0.5);
            if (batch) indices = indices.slice(0, batch);
            const yPredictions = indices.map((index)=>this.model.forward(xs[index]));
            const losses = yPredictions.reduce((acc, yPrediction, index)=>{
                const loss = yPrediction.mul(-ys[indices[index]]).add(1).relu();
                return loss.add(acc);
            }, new (0, $9bnV0.Value)(0));
            const dataLoss = losses.div(yPredictions.length);
            const regLoss = new (0, $9bnV0.Value)(alpha).mul(this.model.parameters().reduce((acc, p)=>acc.add(p.pow(2)), new (0, $9bnV0.Value)(0)));
            const totalLoss = dataLoss.add(regLoss);
            const correct = yPredictions.filter((y, index)=>y.data > 0 === ys[indices[index]] > 0).length;
            const accuracy = correct / yPredictions.length;
            // Backward pass
            this.model.zeroGrad();
            totalLoss.backward();
            // update weights
            learningRate *= 0.99;
            this.model.parameters().forEach((p)=>{
                p.data -= learningRate * p.grad;
            });
            this.model.epoch = epoch;
            this.model.loss = totalLoss.data;
            this.model.accuracy = accuracy;
            this.lossHistory.push(totalLoss.data);
            console.info(`Epoch: ${epoch}, Loss: ${totalLoss.data.toFixed(5)}, Accuracy: ${$f54e63fc4e22fdb3$var$percent(accuracy)}, Learning Rate: ${learningRate.toFixed(5)}`);
            epoch += 1;
            if (epoch > this.maxEpochs) return;
            this.trainId = setTimeout(trainStep, 100);
        };
        trainStep();
    }
    setup() {
        const pattern = this.getPattern();
        console.info(`New model for expression: ${pattern}`);
        this.model = (0, $bfcdf511b23dacc3$export$2e2bcd8739ae039)();
        this.trainingData = (0, $5yyu4.default)(pattern, 100);
        this.lossHistory = [];
        this.training = true;
        this.train();
        (0, $3P6oo.default)(".architecture", $f54e63fc4e22fdb3$var$size, this.model.toString());
    }
    draw() {
        this.clear();
        this.plotBoundaries();
        this.plotPattern();
        this.plotLossCurve();
        const formatter = new Intl.NumberFormat("en-US", {
            style: "decimal",
            maximumFractionDigits: 0
        });
        document.querySelector("#epoch .value").innerText = formatter.format(this.model.epoch);
        document.querySelector("#loss .value").innerText = this.model.loss.toFixed(5);
        document.querySelector("#accuracy .value").innerText = $f54e63fc4e22fdb3$var$percent(this.model.accuracy);
    }
    stop() {
        this.training = false;
        clearTimeout(this.trainId);
        cancelAnimationFrame(this.drawId);
    }
    restart() {
        this.stop();
        this.start();
    }
}
const $f54e63fc4e22fdb3$var$classifier = new $f54e63fc4e22fdb3$var$BinaryClassification({
    canvas: document.getElementById("plane"),
    lossCanvas: document.getElementById("lossCurve"),
    padding: 0,
    width: $f54e63fc4e22fdb3$var$size,
    height: $f54e63fc4e22fdb3$var$size
});
$f54e63fc4e22fdb3$var$classifier.start();
const $f54e63fc4e22fdb3$var$reload = (pattern)=>{
    $f54e63fc4e22fdb3$var$classifier.setPattern(pattern);
    $f54e63fc4e22fdb3$var$classifier.restart();
};
const $f54e63fc4e22fdb3$var$buttons = document.querySelectorAll(".types button");
$f54e63fc4e22fdb3$var$buttons.forEach((button)=>{
    button.addEventListener("click", ()=>{
        const pattern = button.getAttribute("data-pattern");
        $f54e63fc4e22fdb3$var$reload(pattern);
    });
});


//# sourceMappingURL=binary-classification.5d408e17.js.map
